import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Error404 from "MainPages/ErrorPages/error404";
import PropTypes from "prop-types";
import { hasPermission } from "core/Operations/checkPermission";
import { selectUserPermissions } from "core/redux/slice/userPermissionSlice";
import Unauthorized from "MainPages/ErrorPages/unAuthorized";
import { loggedInUser } from "core/redux/slice/authSlice";
// import Unauthorized from "./pages/Unauthorized";

const ProtectedRoute = ({ moduleCode, accessCode, action }) => {
  const userData = useSelector(loggedInUser);
  // const permissions = useSelector(selectUserPermissions);
  const permissions = userData?.permissions;

  const allowed = hasPermission(permissions, moduleCode, accessCode, action);

  //   const hasPermission = permissions?.some(
  //     (perm) =>
  //       perm.formCode === moduleCode &&
  //       perm.subMenu === accessCode &&
  //       perm[action]
  //   );

  const hasAnyChildAccess = () => {
    console.log("Checking child access for:", permissions);
    console.log(moduleCode, accessCode, action);

    // if (!group?.submenuItems?.length) return false;

    const hasChildAccess = permissions?.some(
      (item) => item.menuName === moduleCode && item[action]
    );
    console.log("Child access result:", hasChildAccess);
    return hasChildAccess;
  };

  if (!allowed) {
    const haveChildAccess = hasAnyChildAccess();

    if (!haveChildAccess) {
      return <Unauthorized isError={true} error={"Access Denied"} />;
    } else {
      return <Outlet />;
    }

    
  }

  return <Outlet />; 
};

export default ProtectedRoute;

// // components/ProtectedRoute.jsx
// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { selectUserPermissions } from "core/redux/slice/userPermissionSlice";
// import { hasPermission } from "core/Operations/checkPermission";
// import PropTypes from "prop-types";

// const ProtectedRoute = ({
//   children,
//   moduleCode,
//   accessCode,
//   action = "haveView",
// }) => {
//   const userPermissions = useSelector(selectUserPermissions);
//   const allowed = hasPermission({
//     permissions: userPermissions,
//     formCode: moduleCode,
//     subMenu: accessCode,
//     type: action,
//   });

//   if (!allowed) {
//     return <Navigate to="/unauthorized" replace />;
//   }

//   return children;
// };

ProtectedRoute.propTypes = {
  //   children: PropTypes.node.isRequired,
  moduleCode: PropTypes.string.isRequired,
  accessCode: PropTypes.string.isRequired,
  action: PropTypes.string,
};
// export default ProtectedRoute;
